import type { SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  color?: string
}
export function SearchHintIcon({ color = '#101010', ...props }: Props) {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.16556 4.01147L9.63278 5.23799C10.2791 6.9346 11.568 8.22357 13.2647 8.86994L14.4912 9.33718L13.2647 9.80443C11.568 10.4508 10.2791 11.7398 9.63278 13.4364L9.16556 14.6629L8.69829 13.4364C8.05192 11.7398 6.76296 10.4508 5.0663 9.80443L3.83984 9.33718L5.0663 8.86994C6.76296 8.22357 8.05192 6.9346 8.69829 5.23797L9.16556 4.01147Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.41027 5.70652C5.38016 6.04989 4.46452 6.96552 4.12115 7.99565C3.77778 6.96552 2.86213 6.04989 1.83203 5.70652C2.86213 5.36315 3.77778 4.44751 4.12115 3.4174C4.46452 4.44751 5.38016 5.36315 6.41027 5.70652Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.81468 2.71063C8.24235 2.93954 7.67008 3.39737 7.44122 4.08411C7.21228 3.39737 6.63999 2.93954 6.06771 2.71063C6.75445 2.48172 7.21228 1.90944 7.44122 1.33716C7.67008 1.90944 8.24235 2.36726 8.81468 2.71063Z"
        fill={color}
      />
    </svg>
  )
}
